import { LoaderFunctionArgs, redirect } from 'react-router-dom';

/**
 * The bank's account selection comes back here with `origin` (the page that started it) and its result.
 * Redirecting in a loader is a single navigation; a second one would abort the first page's session refresh.
 */
export function payoutSelectionRedirectLoader({ request }: LoaderFunctionArgs) {
  const searchParams = new URL(request.url).searchParams;
  const origin = searchParams.get('origin');
  searchParams.delete('origin');

  // Only paths within the app, so the callback can't be used to send someone elsewhere
  const pathname = origin?.startsWith('/') && !origin.startsWith('//') ? origin : '/';
  const search = searchParams.toString();

  return redirect(search ? `${pathname}?${search}` : pathname);
}
